module.exports = __webpack_public_path__ + "static/media/mplLogoNew30-07-24.2cd57e51.jpeg";